export const GET_PURCHASE_REQUESTS_REQUEST = "GET_PURCHASE_REQUESTS_REQUEST"
export const GET_PURCHASE_REQUESTS_SUCCESS = "GET_PURCHASE_REQUESTS_SUCCESS"
export const GET_PURCHASE_REQUESTS_FAILURE = "GET_PURCHASE_REQUESTS_FAILURE"
export const GET_NEXT_PAGE_PURCHASE_REQUESTS_REQUEST = "GET_NEXT_PAGE_PURCHASE_REQUESTS_REQUEST"
